import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';
import TextButton from './Buttons/TextButton';
import ImageButton from './Buttons/ImageButton';
import track from '../actions/app';
import convertLabelCharacters from '../utils/labels';
import { getCtaClickTrackingObject } from '../actions/items';
// import { CTA_CLICKED } from '../actions/types';
import './Buttons/ButtonMarkup.scss';

const getButtonMarkup = (btnProps, key) => {
	const button = btnProps.isImage ? (
		<ImageButton
			buttonProps={btnProps}
			handleCtaClicked={() => {
				track(getCtaClickTrackingObject(btnProps.btnLabel));
			}}
		/>
	) : (
		<TextButton
			buttonProps={btnProps}
			handleCtaClicked={() => {
				track(getCtaClickTrackingObject(btnProps.btnLabel));
			}}
		/>
	);
	const containerClass = `price-btn cst-btn-${btnProps.index} mb-3`;
	return (
		<div key={key} className={containerClass}>
			{button}
		</div>
	);
};

export default class ButtonList extends React.Component {
	getButtonLabel(label) {
		const { labels } = this.props;
		return convertLabelCharacters(labels.get(label));
	}
	getButtonHtml(label) {
		const { labels } = this.props;
		return labels && labels.getHTML(label) ? labels.getHTML(label) : label;
	}
	render() {
		const { items, isMobile } = this.props;
		if (items && items.length > 0) {
			return (
				<div className="vehicle-ctas">
					{items.map(item => {
						const btnProps = {
							...item,
							btnLabel: this.getButtonLabel(item.btnLabel)
						};
						const { popoverText, popoverTitle } = btnProps;
						const key = `button-${btnProps.index}`;
						const markup = getButtonMarkup(btnProps, key);
						if (popoverText && !isMobile) {
							const popoverPlacement = 'left';
							const popoverProps = {
								id: `${key}-popover`
							};
							if (popoverTitle) {
								popoverProps.title = this.getButtonLabel(
									popoverTitle
								);
							}

							const popoverHoverFocus = (
								<Popover {...popoverProps}>
									{this.getButtonHtml(popoverText)}
								</Popover>
							);
							return (
								<OverlayTrigger
									key={key}
									trigger={['hover', 'focus']}
									placement={popoverPlacement}
									overlay={popoverHoverFocus}
								>
									{markup}
								</OverlayTrigger>
							);
						}
						return markup;
					})}
				</div>
			);
		}
		return null;
	}
}

ButtonList.propTypes = {
	items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func,
		getHTML: PropTypes.func
	}).isRequired,
	vehicle: PropTypes.shape({}).isRequired,
	isMobile: PropTypes.bool
};

ButtonList.defaultProps = {
	isMobile: false
};



// WEBPACK FOOTER //
// ./src/components/ButtonList.jsx